import { Flecha } from './Iconos.jsx';

/**
 * Barra de progreso y botón de volver.
 *
 * `total` cambia según el negocio: cuando hay un solo profesional ese paso no
 * existe y la barra tiene cuatro tramos en lugar de cinco. Mostrar un paso que
 * nunca se va a ver haría que la barra parezca trabada.
 */
export function Progreso({ paso, total, onVolver, puedeVolver }) {
  return (
    <div className="progreso">
      <button
        type="button"
        className="volver"
        onClick={onVolver}
        disabled={!puedeVolver}
        aria-label="Volver al paso anterior"
      >
        <Flecha />
      </button>

      <div
        className="barras"
        role="progressbar"
        aria-valuenow={paso}
        aria-valuemin={1}
        aria-valuemax={total}
        aria-label={`Paso ${paso} de ${total}`}
      >
        {Array.from({ length: total }, (_, i) => (
          <span
            key={i}
            className={`barra-paso${i + 1 < paso ? ' hecho' : i + 1 === paso ? ' actual' : ''}`}
          />
        ))}
      </div>

      <span className="paso-numero">{paso}/{total}</span>
    </div>
  );
}
